import { useState } from "react";
import HeaderSteps from "../../components/ui/Steps";
import DocumentoFilter from "./components/DocumentoFilter";
import Loader from "../../components/ui/Loader";
import TableCliente from "../clientes/Clientes";
import { Card } from "primereact/card";

function DocumentoPage({
  title,
  tipoDocumento,
  initialRut = "",
  initialCodigo = "",
  initialRazonSocial = "",
  initialLoading = false,
  showFilter = true,
}) {
  const [loading, setLoading] = useState(initialLoading);
  const [rut, setRut] = useState(initialRut);
  const [codigo, setCodigo] = useState(initialCodigo);
  const [razonSocial, setRazonSocial] = useState(initialRazonSocial);
  const [tabla, setTabla] = useState();

  const handleClear = () => {
    setRut("");
    setCodigo("");
    setRazonSocial("");
    setTabla(null);
  };

  return (
    <div className="p-2">
      <Card className="bg-blue-50 border-bottom-1 border-blue-200 py-2 px-3 mb-2">
        <h3 className="m-0 text-blue-700">{title}</h3>
      </Card>
      <Card>
        <div className="col-1">
          <HeaderSteps activeIndex={0} tipoDocumento={tipoDocumento} />
        </div>
        <div className="grid p-fluid">
          <div className={`col-12 ${showFilter ? "" : "hidden"}`}>
            <DocumentoFilter
              codigo={codigo}
              setCodigo={setCodigo}
              rut={rut}
              setRut={setRut}
              razonSocial={razonSocial}
              setRazonSocial={setRazonSocial}
              tipo={tipoDocumento}
              setTabla={setTabla}
              setLoading={setLoading}
              onClear={handleClear}
              onNew={() => {}}
            />
          </div>

          <div className="col-12">
            {loading ? <Loader /> : <TableCliente data={tabla} tipoDocumento={tipoDocumento} />}
          </div>
        </div>
      </Card>
    </div>
  );
}

export default DocumentoPage;
